declare module '@magicpixel/rn-mp-client-sdk' {
  interface InitConfig {
    orgId: string;
    env: 'staging' | 'production';
    projectId: string;
    baseUrl: string;
    logLevel?: 'debug' | 'info' | 'warn' | 'error' | 'none';
    eventDeduplicationWindowMs?: number;
    onInitFailure?: (error: Error) => void;
  }

  interface UserInfo {
    pid?: string;
    email?: string;
    phone?: string;
    country?: string;
    city?: string;
    state?: string;
    fName?: string;
    lName?: string;
    zip?: string;
  }

  interface PageLoadData {
    page_name: string;
    [key: string]: any;
  }

  class MagicPixelImpl {
    init(config: InitConfig): void;
    shutdown(): void;
    recordEvent(eventName: string, payload?: Record<string, any>): void;
    recordPageLoad(data: PageLoadData): void;
    setUserInfo(userInfo: UserInfo): void;
    setCustomerInfo(customerInfo: Record<string, any>): void;
    setDeviceInfo(customFields?: Record<string, any>): void;
    setDeepLinkUrl(url: string): void;
    setFirebaseAppInstanceId(id: string): void;
    getDebugId(): Promise<string | null>;
    setDataLayer(data: Record<string, any>): void;
    persistData(key: string, value: any): void;
    clearPersistedData(keys: string[]): void;
    getDataLayer(): Record<string, any>;
    getEventState(): Record<string, any>;
    hasEventHappened(eventName: string): boolean;
    registerEventProcessor(
      eventType: string,
      callback: (event: any) => void
    ): void;
  }

  export const MagicPixel: MagicPixelImpl;
  export const MagicPixelEventBus: any;
}
